import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BudgetUnitCreateEditProvider } from './context/budget-unit-create-edit-context';
import { BudgetUnitCreateEditComponent } from './budget-unit-create-edit-component';

export function BudgetUnitCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <BudgetUnitCreateEditProvider>
                <BudgetUnitCreateEditComponent />
            </BudgetUnitCreateEditProvider>
        </BaseLayoutFactory>
    );
}
